import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['container', 'averageProgress']

  static values = {
    average: Number
  }

  connect() {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.containerTarget.offsetWidth > 0) {
        this._calculate_progression_dot();
      }
    });

    if (this.containerTarget.offsetWidth > 0) {
      this._calculate_progression_dot();
    } else {
      this.resizeObserver.observe(this.containerTarget);
    }
  }

  disconnect() {
    this._disconnectObserver();
  }

  recalculate_dot() {
    this._calculate_progression_dot();
  }

  _calculate_progression_dot() {
    let average = this.averageValue;

    // We are dividing by 16 because the default font size in browsers is 16px
    // So we use this measurement to converts offsetWidth in pixels to rem units
    let containerLengthInRem = this.containerTarget.offsetWidth/16;

    let percentRem = (containerLengthInRem/100) * average;
    let progressDot = this.averageProgressTarget.children[0].offsetWidth/16;

    if (percentRem < 0.375) {
      this.averageProgressTarget.style.left = '0rem';
    } else if (percentRem > containerLengthInRem - progressDot) {
      this.averageProgressTarget.style.left = `${containerLengthInRem - progressDot}rem`;
    } else {
      this.averageProgressTarget.style.left = `${percentRem - 0.375}rem`;
    }

    this.averageProgressTarget.classList.remove('invisible');

    if (this.containerTarget.offsetWidth > 0) { this._disconnectObserver(); }
  }

  _disconnectObserver() {
    this.resizeObserver?.disconnect();
  }
}
